// extracted by mini-css-extract-plugin
export var displayNone = "_pc-6";
export var imgContainer = "_pc-2";
export var overflowHidden = "_pc-3";
export var productInfoCardButtonContainer = "_pc-5";
export var productTitleText = "_pc-4";
export var rightArrow = "_pc-1";
export var rightArrowContainer = "_pc-0";